import axios from "axios";
import { API_BASE_URL } from "../config";
import { Token } from "@/auth/services/Token.js";
import { store } from "./store";

let activeRequests = 0;

/**
 * TODO: 🟢 alert por cada peticion exitosa
 * TODO: 🟠 redirección por cada peticion no exitosa
 */
const backend = axios.create({
    baseURL: API_BASE_URL
});

backend.interceptors.request.use((config) => {

    activeRequests++;

    store.dispatch("startLoading", true);

    const token = Token.get();

    if (token) {
        config.headers.Authorization = token;
    }

    return config;
});

backend.interceptors.response.use((response) => {

    activeRequests--;

    if (activeRequests === 0) {
        store.dispatch("stopLoading", false);
    }

    return response;
}, (error) => {

    activeRequests--;

    if (activeRequests === 0) {
        store.dispatch("stopLoading", false);
    }
    
    return Promise.reject(error);
});

export { backend };